// ─────────────────────────────────────────────────────────────────
// Glass-i — HR Designations helpers (Stage HRMS-1). Pure JS.
// ─────────────────────────────────────────────────────────────────

let _rowIdCounter = 0;
function nextRowId() { _rowIdCounter += 1; return `hg-c-${_rowIdCounter}`; }

export function normalizeDesignationRows(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((r) => ({
    _clientRowId:    r._clientRowId || (r.id ? `hg-${r.id}` : nextRowId()),
    _dirty:          false,
    id:              r.id || null,
    designationCode: r.designationCode || '',
    designationName: r.designationName || '',
    departmentId:    r.departmentId || null,
    departmentName:  r.departmentName || null,
    active:          r.active !== false
  }));
}

export function markDirtyRow(rows, clientRowId, patch) {
  if (!Array.isArray(rows)) return [];
  return rows.map((r) => r._clientRowId === clientRowId ? { ...r, ...patch, _dirty: true } : r);
}

export function sortDesignations(rows) {
  if (!Array.isArray(rows)) return [];
  return [...rows].sort((a, b) =>
    String((a && a.designationName) || '').localeCompare(String((b && b.designationName) || '')));
}

function trimOrNull(v) {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  return s ? s : null;
}

export function buildDesignationPayload(row) {
  if (!row || typeof row !== 'object') return {};
  return {
    designationCode: trimOrNull(row.designationCode),
    designationName: trimOrNull(row.designationName),
    departmentId:    row.departmentId || null,
    active:          row.active !== false
  };
}

export function buildDesignationBulkPayload(rows, deletedIds = []) {
  const dirty = (rows || []).filter((r) => r && r._dirty);
  return {
    rows: dirty.map((r) => {
      const out = buildDesignationPayload(r);
      if (r.id) out.id = r.id;
      if (r._clientRowId) out._clientRowId = r._clientRowId;
      return out;
    }),
    deletes: Array.isArray(deletedIds)
      ? deletedIds.filter((id) => typeof id === 'string' && id.length > 0) : []
  };
}

export function validateDesignationRow(row, allRows = []) {
  const errors = [];
  if (!row || typeof row !== 'object') {
    return { ok: false, errors: [{ field: 'row', message: 'Row is required.' }] };
  }
  const code = String(row.designationCode || '').trim();
  const name = String(row.designationName || '').trim();
  if (!code) errors.push({ field: 'designationCode', message: 'Designation Code is required.', clientRowId: row._clientRowId });
  if (!name) errors.push({ field: 'designationName', message: 'Designation Name is required.', clientRowId: row._clientRowId });
  if (Array.isArray(allRows) && allRows.length > 0) {
    const peers = allRows.filter((r) => r && r._clientRowId !== row._clientRowId);
    if (code && peers.some((p) => String(p.designationCode || '').trim().toLowerCase() === code.toLowerCase())) {
      errors.push({ field: 'designationCode', message: `Designation Code "${code}" already exists.`, clientRowId: row._clientRowId });
    }
    if (name && peers.some((p) => String(p.designationName || '').trim().toLowerCase() === name.toLowerCase())) {
      errors.push({ field: 'designationName', message: `Designation Name "${name}" already exists.`, clientRowId: row._clientRowId });
    }
  }
  return { ok: errors.length === 0, errors };
}

export function validateDesignationRows(rows) {
  const all = Array.isArray(rows) ? rows : [];
  const errors = [];
  for (const r of all) {
    const { ok, errors: rowErrors } = validateDesignationRow(r, all);
    if (!ok) errors.push(...rowErrors);
  }
  return { ok: errors.length === 0, errors };
}
